<template>
<div class="result">
  <div>
    <div class="result__header">{{labels['bkheader']}}</div>
    <div class="result__value">{{header}}</div>
    <div class="result__note" v-if="header==2" v-html="labels['bk2note']"></div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Result',
  props: ['value', 'labels'],
  computed: {
    header () {
      return this.value.substr(2, 3)
    }
  }
}
</script>

<style scoped lang="scss">
.result {
    display: flex;
    align-items: center;
    justify-content: center;

    height: 300px;

    text-align: center;

    .result__header {
        font-size: 40px;
        line-height: 40px;
    }
    .result__value {
      font-size: 80px;
      line-height: 80px;
    }
    .result__note {
      margin-top: 50px;
      text-align: left;
      border: 1px solid #56b4ee;
      padding: 15px;
      max-height: 400px;
      overflow-y: scroll;
      box-shadow: 3px 3px #cae1f1;
    }
}
@media only screen and (min-width: 769px) {
    .result {
        height: 600px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Result.vue